import { useCheckRelations } from "components/common";
import { AuthEnums } from "models/enums";

function useFinancialReportPermissions() {
  const { hasRelation, getIsRevisor } = useCheckRelations();
  const hasPermissions = () => {
    return hasRelation(AuthEnums.PersonCompanyRelationType.Reports) || getIsRevisor();
  };

  const hasChartsPermissions = () => {
    return hasRelation(AuthEnums.PersonCompanyRelationType.Reports);
  };
  return { hasPermissions, hasChartsPermissions };
}

export default useFinancialReportPermissions;
